var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _vm.isLocationOriginal
        ? _c(
            "v-row",
            {
              staticClass: "mb-4"
            },
            [
              _c(
                "v-col",
                {
                  attrs: {
                    cols: "12",
                    md: "6"
                  }
                },
                [
                  _c(
                    "gg-card-title",
                    {
                      staticClass: "pb-0"
                    },
                    [_vm._v(" " + _vm._s(_vm.title) + " ")]
                  )
                ],
                1
              ),
              _c(
                "v-col",
                {
                  staticClass: "text-right mt-2",
                  attrs: {
                    cols: "12",
                    md: "6"
                  }
                },
                [
                  _c(
                    "div",
                    [
                      _c(
                        "gg-btn",
                        {
                          staticClass: "mt-1 mr-1",
                          attrs: {
                            right: "",
                            to: {
                              name: "support_ticketnew"
                            }
                          }
                        },
                        [_vm._v(" Open new ticket ")]
                      )
                    ],
                    1
                  )
                ]
              )
            ],
            1
          )
        : _vm._e(),
      _c(
        "gg-loading",
        {
          staticClass: "dashboard-fill-height",
          attrs: {
            loading: !_vm.ticketsPopulated,
            type: "table"
          }
        },
        [
          _c(
            "div",
            [
              _c(
                "gg-card",
                {
                  attrs: {
                    height: "100%"
                  }
                },
                [
                  _c(
                    "gg-card-header",
                    [
                      _vm.isLocationOriginal
                        ? [
                            _vm._v(" " + _vm._s(_vm.subtitle) + " "),
                            _c(
                              "gg-btn",
                              {
                                staticClass: "float-right",
                                attrs: {
                                  disabled: _vm.loading
                                },
                                on: {
                                  click: _vm.getTicketsData
                                }
                              },
                              [_c("v-icon", [_vm._v(" mdi-refresh ")])],
                              1
                            )
                          ]
                        : _vm._e(),
                      !_vm.isLocationOriginal
                        ? _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    cols: "6",
                                    md: "4"
                                  }
                                },
                                [_vm._v(" " + _vm._s(_vm.title) + " ")]
                              ),
                              _c(
                                "v-col",
                                {
                                  staticClass: "text-right",
                                  attrs: {
                                    cols: "6",
                                    md: "8"
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "hidden-xs-only"
                                    },
                                    [
                                      _c(
                                        "gg-btn",
                                        {
                                          staticClass: "mx-1",
                                          attrs: {
                                            secondary: "",
                                            disabled: _vm.loading,
                                            right: ""
                                          },
                                          on: {
                                            click: _vm.getTicketsData
                                          }
                                        },
                                        [
                                          _c("v-icon", [
                                            _vm._v(" mdi-refresh ")
                                          ]),
                                          _c(
                                            "span",
                                            {
                                              staticClass: "visually-hidden"
                                            },
                                            [_vm._v("Refresh tickets")]
                                          )
                                        ],
                                        1
                                      ),
                                      _c(
                                        "gg-btn",
                                        {
                                          staticClass: "mx-1",
                                          attrs: {
                                            right: "",
                                            to: {
                                              name: "support_ticketnew"
                                            }
                                          }
                                        },
                                        [_vm._v(" Open New Ticket ")]
                                      ),
                                      _c(
                                        "gg-btn",
                                        {
                                          staticClass: "mx-1",
                                          attrs: {
                                            secondary: "",
                                            right: "",
                                            to: {
                                              name: "support_ticketlist"
                                            }
                                          }
                                        },
                                        [_vm._v(" All tickets ")]
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "hidden-sm-and-up py-0"
                                    },
                                    [
                                      _c(
                                        "v-menu",
                                        {
                                          attrs: {
                                            bottom: "",
                                            left: "",
                                            "offset-y": ""
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "activator",
                                                fn: function fn(_ref) {
                                                  var on = _ref.on
                                                  return [
                                                    _c(
                                                      "gg-btn",
                                                      _vm._g(
                                                        {
                                                          staticClass: "ml-0",
                                                          attrs: {
                                                            secondary: ""
                                                          }
                                                        },
                                                        on
                                                      ),
                                                      [
                                                        _vm._v(" Actions "),
                                                        _c(
                                                          "v-icon",
                                                          {
                                                            attrs: {
                                                              right: "",
                                                              dark: ""
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "mdi-menu-down"
                                                            )
                                                          ]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            false,
                                            1620838047
                                          )
                                        },
                                        [
                                          _c(
                                            "v-list",
                                            [
                                              _c(
                                                "v-list-item",
                                                {
                                                  attrs: {
                                                    to: {
                                                      name: "support_ticketnew"
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("v-list-item-title", [
                                                    _vm._v("Open new ticket")
                                                  ])
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-list-item",
                                                {
                                                  attrs: {
                                                    to: {
                                                      name: "support_ticketlist"
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("v-list-item-title", [
                                                    _vm._v("All tickets")
                                                  ])
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-list-item",
                                                {
                                                  on: {
                                                    click: function click(
                                                      $event
                                                    ) {
                                                      return _vm.getTicketsData(
                                                        true
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("v-list-item-title", [
                                                    _vm._v(
                                                      "Refresh tickets list"
                                                    )
                                                  ])
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    2
                  ),
                  _c(
                    "gg-card-text",
                    [
                      _vm.isLocationOriginal
                        ? _c("services-search", {
                            model: {
                              value: _vm.search,
                              callback: function callback($$v) {
                                _vm.search = $$v
                              },
                              expression: "search"
                            }
                          })
                        : _vm._e(),
                      _c("v-data-table", {
                        attrs: {
                          "hide-default-footer": false,
                          headers: _vm.headers,
                          items: _vm.formatted_tickets,
                          loading: _vm.loading,
                          search: _vm.search,
                          "sort-by": "last_activity",
                          "sort-desc": "",
                          "footer-props": {
                            itemsPerPageOptions: this.pagination
                          }
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "item.department",
                            fn: function fn(_ref2) {
                              var item = _ref2.item
                              return [
                                _c(
                                  "div",
                                  [
                                    _c("v-icon", [_vm._v("mdi-folder")]),
                                    _vm._v(" " + _vm._s(item.department) + " ")
                                  ],
                                  1
                                )
                              ]
                            }
                          },
                          {
                            key: "item.title",
                            fn: function fn(_ref3) {
                              var item = _ref3.item
                              return [
                                _c(
                                  "router-link",
                                  {
                                    attrs: {
                                      to: "/support/ticket/".concat(
                                        item.ticket_id
                                      )
                                    }
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "d-none d-sm-flex"
                                      },
                                      [_vm._v(_vm._s(item.title))]
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticClass: "d-flex d-sm-none"
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.textTruncate(
                                              item.title_mobile,
                                              20
                                            )
                                          )
                                        )
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("br"),
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.compact,
                                        expression: "compact"
                                      }
                                    ]
                                  },
                                  [
                                    _c("v-icon", [_vm._v("mdi-folder")]),
                                    _vm._v(" " + _vm._s(item.department) + " ")
                                  ],
                                  1
                                )
                              ]
                            }
                          },
                          {
                            key: "item.related_service_text",
                            fn: function fn(_ref4) {
                              var item = _ref4.item
                              return [
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      href: "#"
                                    },
                                    on: {
                                      click: function click($event) {
                                        $event.preventDefault()
                                        return _vm.navigateTo(
                                          item.related_service
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(item.related_service_text) +
                                        " "
                                    )
                                  ]
                                ),
                                item.sharedaccount || item.sharedaccess
                                  ? _c(
                                      "router-link",
                                      {
                                        staticClass: "pl-1",
                                        attrs: {
                                          to: {
                                            name: "profile_access"
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "v-icon",
                                          {
                                            attrs: {
                                              small: ""
                                            }
                                          },
                                          [_vm._v("mdi-account-multiple")]
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ]
                            }
                          },
                          {
                            key: "item.status",
                            fn: function fn(_ref5) {
                              var item = _ref5.item
                              return [
                                _c(
                                  "div",
                                  [
                                    item.status == "In Progress"
                                      ? _c(
                                          "v-chip",
                                          {
                                            staticClass: "ma-2",
                                            attrs: {
                                              label: "",
                                              color: "green",
                                              "text-color": "white"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              " " + _vm._s(item.status) + " "
                                            )
                                          ]
                                        )
                                      : item.status == "Closed"
                                      ? _c(
                                          "v-chip",
                                          {
                                            staticClass: "ma-2",
                                            attrs: {
                                              label: "",
                                              color: "red",
                                              "text-color": "white"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              " " + _vm._s(item.status) + " "
                                            )
                                          ]
                                        )
                                      : _c(
                                          "v-chip",
                                          {
                                            staticClass: "ma-2",
                                            attrs: {
                                              label: ""
                                            }
                                          },
                                          [
                                            _vm._v(
                                              " " + _vm._s(item.status) + " "
                                            )
                                          ]
                                        )
                                  ],
                                  1
                                )
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }